import React from 'react';
import { ContainerComponent, wrap } from 'AppReact';
import Controller from './controller';
import { Icon, BorderlessKeyInput } from 'atoms';
import { FilterHeaderWrapper, RelativeWrapper, RowCenterScrollWrapper, FlexCenterJustifyCenterWrapper, FlexBoxWrapper, FlexGrowCenterOverflowHiddenWrapper, UnitDropdownBodyWrapper } from 'wrappers';
import internalState from './internalState';
import { HomeSvg, PlusSignSvg } from 'components/icons';
import { UnitRow } from './molecules';
import { DropdownTextButton, TextButton, IconTextButton } from 'molecules';
import { getFilteredUnits, getUnits } from './utils';

const containerRef = React.createRef();
const headerRef = React.createRef();

export const definition = {
  name: 'UnitSelector',
  controller: Controller,
  initialProps: ({ properties, units, selectedUnitIds, openOnTop, hideAddUnitButton, isAddUnitButtonExternalFunction, isUnitMultiSelectionAllowed, showResident}) => ({ properties, units, selectedUnitIds, openOnTop, hideAddUnitButton, isAddUnitButtonExternalFunction, isUnitMultiSelectionAllowed, showResident }),
  props: internalState,
  elements: [
    {
      wrapper: FilterHeaderWrapper,
      name: 'HeaderWrapper',
      ref: headerRef,
      isButton: true,
      bindings: ({ isOpen, selectedUnitIds, isUnitMultiSelectionAllowed }) => ({ isOpen, containerRef, selectedUnitIds, isUnitMultiSelectionAllowed }),
      elements: [
        {
          wrapper: FlexGrowCenterOverflowHiddenWrapper,
          name: 'LeftSideWrapper',
          elements: [
            {
              component: Icon,
              name: 'Icon',
              displayValue: ({ }) => HomeSvg({ selected: true })
            },
            {
              wrapper: RowCenterScrollWrapper,
              name: 'Wrapper',
              elements: [
                {
                  component: DropdownTextButton,
                  name: 'SelectedButton',
                  isListOf: 'selectedUnitIds',
                  bindings: ({ selectedUnitId, selectedUnitIds, units }) => {
                    let unit = units.find(unit => unit.id == selectedUnitId);
                    return { text: unit ? `Unit ${unit.number}` : '', units, selectedUnitIds, id: unit.id }
                  }
                },
                {
                  component: BorderlessKeyInput,
                  name: 'SearchInput',
                  bindings: ({ searchTerm, isUnitMultiSelectionAllowed, selectedUnitIds }) => ({ isUnitMultiSelectionAllowed, selectedUnitIds, value: searchTerm, placeholder: "Search Units" })
                }
              ]
            }
          ]
        },
        {
          component: IconTextButton,
          name: 'AddUnit',
          renderIf: ({ selectedUnitIds, hideAddUnitButton }) => selectedUnitIds.length > 0 && !hideAddUnitButton,
          bindings: ({ isOpen, isAddUnitButtonExternalFunction, selectedUnitIds }) => ({ title: 'Add Unit', icon: PlusSignSvg({}), isOpen, isAddUnitButtonExternalFunction, selectedUnitIds })
        },
      ]
    },
    {
      wrapper: UnitDropdownBodyWrapper,
      name: 'Body',
      ref: containerRef,
      renderIf: ({ isOpen }) => isOpen,
      displayState: ({ openOnTop }) => ({ openOnTop }),
      elements: [
        {
          component: UnitRow,
          name: 'Unit',
          isListOf: { unit: getUnits },
          bindings: ({ properties, unit, selectedUnitIds, showResident }) => ({ selectedUnitIds, showResident, property: properties.find(property => property.id === unit.property_id), unit }),
        },
        {
          component: wrap(wrap(TextButton, FlexBoxWrapper), FlexCenterJustifyCenterWrapper),
          name: 'LoadMore',
          renderIf: ({ units, searchTerm, properties, selectedUnitIds, pageNumber }) => (pageNumber * 10) < getFilteredUnits({ units, searchTerm, properties, selectedUnitIds }).length,
          bindings: ({ pageNumber }) => ({ title: 'Load More...', pageNumber })
        }
      ]
    }
  ]
}

const UnitSelector = ContainerComponent(definition)

export default wrap(UnitSelector, RelativeWrapper)
